import { proxy, ref } from 'valtio'
import * as React from 'react'

const initialState = {
    drawerOpen: false,
    children: null as React.ReactNode,
    drawerSize: 0 as number | string,
    petList: true,
}

export const drawerState = proxy({ ...initialState })

/** Opens/closes the drawer, adjusting size accordingly */
export function setDrawerOpen(open: boolean) {
    drawerState.drawerOpen = open
    drawerState.drawerSize = open ? 'auto' : 0
}

/** Set the drawer's child content. Wrapped with ref() to prevent deep proxying of React elements */
export function setDrawerChildren(children: React.ReactNode) {
    drawerState.children = children ? (ref(children as object) as unknown as React.ReactNode) : null
}

export function showPetList(show: boolean) {
    drawerState.petList = show
}

export function resetDrawer() {
    drawerState.drawerOpen = false
    drawerState.children = null
    drawerState.drawerSize = 10
    // petList intentionally not reset
}

export default drawerState
